export default "__VITE_ASSET__DwSuVhgA__"